import React, { useState } from "react";
import SideBarWrapper from "../../common/sidebarWrapper";
import styles from "./Deposit.module.scss";
import InfoTopBar from "../../common/InfoTopBar/InfoTopBar";
import LoginSignUp from "../../common/LoginSignUp/LoginSignUp";
import CommonTable from "../../common/CommonTable/CommonTable";
import CreateRequest from "../CreateRequest/CreateRequest";
import SubmitDepositRequest from "../SubmitDepositRequest/SubmitDepositRequest";
export default function Deposit() {
  const headings = ["Amount", "Status", "Type", "Date"];
  const [isCreated, setIsCreated] = useState(false);
  const handleClick = () => {
    setIsCreated(!isCreated);
  };
  return (
    <SideBarWrapper>
      <div className={styles.wrapper}>
        <InfoTopBar heading="Deposit" info="Use below interface to Deposit .">
  {/*  <LoginSignUp /> */}
       
        </InfoTopBar>
        <div className={styles.flexWrapper}>
          {!isCreated ? (
            <div className={styles.formWrapper} style={{ maxHeight: "443px" }}>
              <CreateRequest handleClick={handleClick} />
            </div>
          ) : (
            <div className={styles.formWrapper}>
              <SubmitDepositRequest handleClick={handleClick} />
            </div>
          )}
          <div className={styles.tableWrapper}>
            <CommonTable
              tableHeadings={headings}
              heading="Recent Deposit History"
              maxHeight={!isCreated ? "385px" : "540.425px"}
            />
          </div>
        </div>
      </div>
    </SideBarWrapper>
  );
}
